var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#0095FF","cx":"25.61","cy":"25.61","r":"25.61","key":0}),React.createElement("g",{"fill":"none","stroke":"#FFF","strokeWidth":"2","strokeLinecap":"round","strokeMiterlimit":"10","key":1},[React.createElement("polyline",{"points":"33.9,26.84 25.61,35.12 17.33,26.84","key":0}),React.createElement("line",{"x1":"25.61","y1":"34.71","x2":"25.61","y2":"12.82","key":1})])]);
}

Download.defaultProps = {"width":"50","viewBox":"0 0 51.22 51.22","style":{"enableBackground":"new 0 0 51.22 51.22"},"xmlSpace":"preserve"};

module.exports = Download;

Download.default = Download;
